import { useSelector } from "react-redux";
import { getCardMasterData } from "../../Utility/Utility";

export function useCardRedemption({ clientInfo, selectedCardBasedRedemtion }) {
  const cardMasterData =
    useSelector((state) => state.cardMasterReducer?.cardMasterData) || [];

  const journeyType = clientInfo?.clientData?.journeyType;
  const isWalletJourney =
    journeyType === true ||
    journeyType === 1 ||
    String(journeyType).trim().toLowerCase() === "true" ||
    String(journeyType).trim() === "1";
  const isCardJourney = !isWalletJourney;
  const MatchedCardMasterData = getCardMasterData(
    selectedCardBasedRedemtion?.CardTypeName,
    cardMasterData,
  );
  const shouldApplyCardToggle = isCardJourney;
  const hasMatchedCardMasterData = !!MatchedCardMasterData;

  const isEarnEnabledForSelectedCard =
    !shouldApplyCardToggle ||
    !hasMatchedCardMasterData ||
    MatchedCardMasterData?.earnEnabled !== false;

  const isBurnEnabledForSelectedCard =
    !shouldApplyCardToggle ||
    !hasMatchedCardMasterData ||
    MatchedCardMasterData?.burnEnabled !== false;

  // true → use offer ID from order response; false → use PG code from card master
  const razorPayOfferCode =
    !shouldApplyCardToggle ||
    !hasMatchedCardMasterData ||
    !MatchedCardMasterData?.razorpayPgCode;

  const payuOfferCode =
    !shouldApplyCardToggle ||
    !hasMatchedCardMasterData ||
    !MatchedCardMasterData?.payUPgCode;

  return {
    journeyType,
    cardMasterData,
    MatchedCardMasterData,
    isEarnEnabledForSelectedCard,
    isBurnEnabledForSelectedCard,
    razorPayOfferCode,
    payuOfferCode,
  };
}
